import React from 'react'

import LazyLoad from '../../atoms/LazyLoad'
import Placeholder from '../../atoms/Placeholder'
import Image from '../../atoms/Image/WithPolyfill'
import Wrapper from '../../atoms/Image/Container'

export default ({ initialInView, className, children, ...props }) => (
  <Wrapper className={className}>
    <LazyLoad initialInView={initialInView}>
      <Image {...props} />
    </LazyLoad>
    {props.relative ? null :<Placeholder />}
    {children}
  </Wrapper>
)
